import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TransactionList } from '../components/TransactionList';
import { useCurrency } from '../hooks/useCurrency';

export function TransactionHistory() {
  const navigate = useNavigate();
  const currency = useCurrency();

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="bg-black/50 text-white p-4 flex items-center justify-between sticky top-0 z-10 backdrop-blur-lg border-b border-white/10">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-lg font-bold">Historique des transactions</h1>
        <div className="w-6" /> {/* Spacer for alignment */}
      </div>

      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <TransactionList currency={currency} />
      </div>
    </div>
  );
}